export const CTA_URL =
  "https://dentistas.impultienda.ar/checkout/dentistas";

export const BRAND = {
  navy: "#0f2547",
  navyDeep: "#0a1a34",
  blue: "#1e88e5",
  blueBright: "#2196f3",
  gold: "#f5a623",
};
